export const API_URL = 'https://trc4.tpsre.api.dsml.ru/'
export const CONFIRMATION_GENERATOR_ID = 'c250c8ad-5d9d-479d-8080-536ec7f807ab'
export const EMAIL_CONFIRMATION_GENERATOR_ID = '8b77483d-f521-4344-8a52-b723228e021b'
export const PERSONAL_DATA_CONSENT_ID = '6eb25fcc-859b-4023-9a82-b5c43d4b40ad'
export const COMMUNICATIONS_CONSENT_ID = '3b0d4170-6bf2-41f1-883a-b7eb34ba03cc'
export const RULES_CONSENT_ID = 'b65f5aaf-96b5-46fd-8347-73899210baf6'
export default API_URL



// WEBPACK FOOTER //
// ./src/common/config.js